import React, { useContext } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import { doSuggest } from "../../helpers/search";
import { ISquizSuggestion } from "../../helpers/squiz";
import { useDebounce } from "../../helpers/useDebounce";
import { Autocomplete } from "./Autocomplete";
import { Section } from "@origin-digital/ods-core";
import { FullPageCoverContainer } from "./styles";
import { AppContext } from "../../AppContext";

const Container = styled.div`
  padding: ${(props) => props.theme.space.xlarge}px 0;
  position: relative; // allow dropdown to attach to this container
  background-color: white;
`;

export const Search = () => {
  const { config } = useContext(AppContext);
  const [searchParams] = useSearchParams();

  const [query, setQuery] = React.useState(searchParams.get("term") || "");
  const [suggestions, setSuggestions] = React.useState<ISquizSuggestion[]>([]);
  const [focused, setFocusState] = React.useState<boolean>(false);

  const searchQuery = useDebounce(query, 200);

  React.useEffect(() => {
    (async () => {
      const values = await doSuggest(query, config.env);
      setSuggestions(values);
    })();
  }, [searchQuery]);

  // when the searchTerm changes (usually due to back button press)
  // this should be reflected in the query/input field
  React.useEffect(() => {
    const searchTerm = searchParams.get("term");
    if (searchTerm !== query) setQuery(searchTerm || "");
  }, [searchParams]);

  return (
    <Container>
      <Section backgroundColor="white" paddingY="none">
        <Autocomplete
          onFocusChange={setFocusState}
          inputValue={query}
          setInputValue={setQuery}
          suggestions={suggestions.map((s) => s.disp)}
        />
      </Section>
      <FullPageCoverContainer show={focused} />
    </Container>
  );
};
